import { DateTime } from "luxon";
import { api, formDataAPI, urlEncodedAPI } from "./axios";

// home page apis
export const getCategoryList = () => api(`coach/category-list`, "GET");
export const getTestimonials = () => api(`testimonials`, "GET");
export const getShortVideos = () => api(`shortVideos`, "GET");
export const getTrendingCoach = () => api(`coach/trending-list`, "GET");
export const getLatestCoachShorts = () => api(`common/home/latest-coach-shorts`, "GET");
export const getLatestCoachPosts = () => api(`common/home/latest-coach-posts`, "GET");

// common apis
export const getCountries = () => api(`countries`, "GET");
export const getStates = (query) => api(`states?country=${query}`, `GET`);
export const getLanguages = () => api(`languages`, "GET");
export const openAPI = (data) => api(`openAi/process`, "POST", data);
export const promptMatch = (data) => api("openAi/prompt/match", "POST", data);
export const sendAIChatMessage = (data) => api("openAi/ai-chat", "POST", data);
export const extractBioResumeData = (data) =>
  formDataAPI(`openAi/extract/data`, "POST", data);

// user-coach auth api's
export const authSignup = (data) => api(`auth/signup`, "POST", data);
export const authLogin = (data) => api(`auth/signin`, "POST", data);
export const forgetPassword = (data) =>
  api(`auth/forget-password`, "POST", data);
export const updatePassword = (data) =>
  api(`auth/update-password`, "POST", data);
export const verifyResetPasswordToken = (token) =>
  api(`auth/verify-reset-password/${token}`, "GET");

// user-auth apis
export const userLogin = (data) => api(`users/auth`, "POST", data);

//  user-auth apis
export const userUpdate = (data) => api(`users/update`, "PATCH", data);
export const userImage = (data) => formDataAPI(`users/image`, "PUT", data);

// coach-auth apis
export const coachLinkedin = (code, userType) =>
  api(`auth/getUserCredentials?code=${code}&userType=${userType}`, "GET");
export const coachLogin = (data) => api(`coach/auth`, "POST", data);
export const coachUpdate = (data) => formDataAPI(`coach/update`, "PATCH", data);
export const coachChangePassword = (data) =>
  api(`auth/change-password`, "POST", data);
export const coachImage = (data) => formDataAPI(`coach/image`, "PUT", data);
export const coachBGImage = (data) =>
  formDataAPI(`coach/bg-image`, "PATCH", data);

// coach-list apis
export const getCoaches = () => api(`coach/list`, "GET");
export const getCoachById = (id) => api(`coach/${id}`, "GET");
export const getCoachBySlug = (slug) => api(`coach/${slug}`, "GET");

// coach-language apis
export const coachAddLanguage = (data) =>
  api(`coach/add-language`, "POST", data);
export const coachDeleteLanguage = (data) =>
  api(`coach/delete-language`, "POST", data);

// coach-speciality apis
export const searchSpecialtiesByName = (name, page, limit) =>
  api(`specialities?name=${name}&page=${page}&limit=${limit}`, "GET");

// coach-program apis
export const coachAddProgram = (data) => api(`coach/add-program`, "POST", data);
export const coachProgramLists = (data) => api(`coach/program/list`, "GET");
export const coachProgramDetails = (id) =>
  api(`coach/program/${id}/details`, "GET");
export const coachUpdateProgram = (data) =>
  api(`coach/update-program`, "POST", data);
export const coachDeleteProgram = (data) =>
  api(`coach/delete-program`, "POST", data);
export const coachDeleteProgramSession = (data) =>
  api(`coach/delete-sessions`, "POST", data);
export const coachCancelProgramSession = (data) =>
  api(`coach/program/coach-user/slot-cancel`, "POST", data);

// coach-skill apis
export const coachAddSkill = (data) => api(`coach/add-skill`, "POST", data);
export const coachDeleteSkill = (data) =>
  api(`coach/delete-skill`, "POST", data);

// coach-certificate apis
export const coachAddCertificate = (data) =>
  formDataAPI(`coach/add-certificate`, "POST", data);
export const coachDeleteCertificate = (data) =>
  api(`coach/delete-certificate`, "POST", data);
export const coachUpdateCertificate = (data) =>
  api(`coach/update-certificate`, "POST", data);

// coach-experience apis
export const coachAddExperience = (data) =>
  api(`coach/add-experience`, "POST", data);

export const coachStartSession = (data) =>
  api(`coach/program/coach/start-session`, "POST", data);

export const coachJoinSession = (data) =>
  api(`coach/program/user/join-session`, "POST", data);

export const joinSessionMeeting = (sessionId, socketId, force = false) =>
  api(`meeting/session/${sessionId}/join?${socketId ? `socketId=${socketId}&` : ""}${force ? "force=true" : ""}`, "GET");

export const endSessionMeeting = (sessionId) =>
  api(`meeting/session/${sessionId}/end`, "POST");

export const coachDeleteExperience = (data) =>
  api(`coach/delete-experience`, "POST", data);
export const coachUpdateExperience = (data) =>
  api(`coach/update-experience`, "POST", data);

// coach-education apis
export const coachAddEducation = (data) =>
  api(`coach/add-education`, "POST", data);
export const coachUpdateEducation = (data) =>
  api(`coach/update-education`, "POST", data);
export const coachDeleteEducation = (data) =>
  api(`coach/delete-education`, "POST", data);

// coach-testimonials apis
export const coachAddTestimonial = (data) =>
  formDataAPI(`coach/add-testimonial`, "POST", data);
export const coachDeleteTestimonial = (data) =>
  api(`coach/delete-testimonial`, "POST", data);

// coach-post apis
export const coachAddPost = (data) => formDataAPI(`coach/post`, "POST", data);
export const coachEditPostFormData = (id, data) =>
  formDataAPI(`coach/post/${id}`, "PATCH", data);
export const coachEditPost = (id, data) =>
  api(`coach/post/${id}`, "PATCH", data);
export const coachGetMyPost = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return api(`coach/post/get-my${query ? `?${query}` : ''}`, "GET");
};
export const getPostByCoachId = (id) => api(`coach/post/list/${id}`, "GET");

/* ?page=${data.page}&limit=${data.limit} */
// Build query string but support arrays by appending the same key multiple times
const buildQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    // If value is an array, append each item as a separate key occurrence
    if (Array.isArray(value)) {
      value.forEach((v) => {
        // convert objects to JSON strings, primitives as-is
        if (typeof v === "object") searchParams.append(key, JSON.stringify(v));
        else searchParams.append(key, String(v));
      });
    } else if (typeof value === "object") {
      // For objects, stringify (fallback)
      searchParams.append(key, JSON.stringify(value));
    } else {
      searchParams.append(key, String(value));
    }
  });
  return searchParams.toString();
};

export const getFilteredCoaches = (params = {}) => {
  const query = buildQueryString(params);
  const url = `coach/list${query ? `?${query}` : ""}`;
  console.log("API Call - URL:", url);
  console.log("API Call - Params:", params);
  return api(url, "GET");
};
export const getUserMyCoaches = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const url = `users/mycoaches/list${query ? `?${query}` : ""}`;
  console.log("API Call - URL:", url);
  console.log("API Call - Params:", params);
  return api(url, "GET");
};
export const coachDeletePost = (id) => api(`coach/post/${id}`, "DELETE");
export const getPosts = (data) => {
  if (data !== undefined) {
    return api(
      `coach/post/list?page=${data.page}&limit=${data.limit}`,
      "GET",
      data
    );
  } else {
    return api(`coach/post/list`, "GET", data);
  }
};
// data !== undefined
//   ? api(`coach/post/list?search=${data}`, "GET", data)
//   : api(`coach/post/list`, "GET", data);

export const coachAddShortVideo = (data) =>
  formDataAPI(`coach/shorts`, "POST", data);

export const userRescheduleSession = (data, timezone = "UTC") =>
  api(`coach/program/user-reschedule-session?timezone=${timezone}`, "POST", data);

export const coachRescheduleSession = (data, timezone = "UTC") =>
  api(`coach/program/coach-reschedule-session?timezone=${timezone}`, "POST", data);

export const coachEditShortVideoData = (id, data) =>
  formDataAPI(`coach/shorts/${id}`, "PATCH", data);
export const coachEditShortVideo = (id, data) =>
  api(`coach/shorts/${id}`, "PATCH", data);
export const coachGetMyShortVideo = (params = {}) => {
  const queryParams = {};

  // Handle pagination
  if (params.page || params.pageNumber) {
    queryParams.page = params.page || params.pageNumber || 1;
  }
  if (params.limit || params.pageLimit) {
    queryParams.limit = params.limit || params.pageLimit || 10;
  }

  // Handle type parameter
  if (params.type) {
    queryParams.type = params.type;
  }

  // Handle coach_id parameter - required when user is logged in
  if (params.coach_id) {
    queryParams.coach_id = params.coach_id;
  }

  const query = new URLSearchParams(queryParams).toString();
  return api(`coach/shorts/get-my${query ? `?${query}` : ''}`, "GET");
};
export const getShortVIdeoByCoachId = (id) =>
  api(`coach/shorts/list/${id}`, "GET");
export const coachDeleteShortVideo = (id) =>
  api(`coach/shorts/${id}`, "DELETE");
export const getShorts = () => api(`coach/shorts/list`, "GET");

export const coachAddCaseStudies = (data) =>
  formDataAPI(`coach/caseStudies`, "POST", data);
export const coachEditCaseStudy = (id, data) =>
  formDataAPI(`coach/caseStudies/${id}`, "PATCH", data);
export const coachGetMyCaseStudies = (data) =>
  api(`coach/caseStudies/get-my`, "GET", data);
export const coachGetCaseStudies = (id) =>
  api(`coach/caseStudies/list/${id}`, "GET");
export const coachDeleteCaseStudies = (id) =>
  api(`coach/caseStudies/${id}`, "DELETE");

export const addLikeInShort = (data) =>
  urlEncodedAPI(`coach/shorts/like-dislike`, "POST", data);
export const addComment = (data) => api(`coach/post/comment`, "POST", data);
export const deletePostComment = (id) =>
  api(`coach/post/comments/${id}`, "DELETE");
export const deleteVideoComment = (id) =>
  api(`coach/shorts/comments/${id}`, "DELETE");
export const addCommentShortVideo = (data) =>
  urlEncodedAPI(`coach/shorts/comment`, "POST", data);

export const addLike = (data) => api(`coach/post/like-dislike`, "POST", data);
export const getCommentPostById = (id) =>
  api(`coach/post/comments/${id}`, "GET");
export const getLikesPostById = (id) => api(`coach/post/getLikes/${id}`, "GET");
export const getCommentShortVideoById = (id) =>
  api(`coach/shorts/comments/${id}`, "GET");

// followers coach
export const followUnfollowCoach = (data) =>
  api(`coach/followers`, "POST", data);

export const onlyFollowCoach = (data) =>
  api(`coach/followers/only-follow`, "POST", data);

export const getMyFollowings = (data) => api(`coach/followers/list`, "GET");

// coach-tag apis
export const coachTags = (data) => api(`coach/tags`, "POST", data);

// coach-benfit/professions apis
export const coachBenefits = (data) => api(`coach/benefit`, "POST", data);
export const coachProfessions = (data) =>
  api(`coach/professions`, "POST", data);

// auth
export const getLoggedInUser = (data) => api(`auth/me`, "POST", data);

// stripe
export const addPlan = (data) => api(`stripe`, "POST", data);
export const createEscrowPayment = (data) => api(`stripe/escrow/create`, "POST", data);
export const syncEscrowPayment = (paymentId) => api(`stripe/escrow/sync/${paymentId}`, "GET");
export const getEscrowPayments = () => api(`stripe/escrow/all`, "GET");
export const getStripeOnboardingLink = () => api(`stripe/coach/create-account`, "POST", {});
export const getStripeAccountStatus = (coachId) => api(`stripe/coach/status/${coachId}`, "GET");
export const getStripeConnectAccountDetails = (accountId) => api(`stripe/connect/account/${accountId}`, "GET");
export const getStripeLoginLink = () => api(`stripe/coach/login-link`, "POST", {});

// contactus
export const contactus = (data) => api(`contactus`, "POST", data);

// Chat Module API

export const getConversationList = (data) => api(`chat/list`, "GET");

export const sendMessage = (data) => api(`chat/sendMessage`, "POST", data);
export const messageSeen = (data) => api(`chat/messageSeen`, "POST", data);
export const oldMessages = (data) =>
  api(
    `chat/oldMessages` +
    "?id=" +
    data.id +
    "&limit=" +
    data.limit +
    "&page=" +
    data.page,
    "GET"
  );
export const deleteConversation = (id) =>
  api(`chat/deleteConversation/${id}`, "DELETE");

export const getFilterCoachOfUserInterest = (query) =>
  api(`coach/filterlist?search=${query}`, `GET`);

export const searchCoachWithText = (query) =>
  api(`coach/search?search=${query}`, `GET`);

export const getAllBlogs = (data = {}) => urlEncodedAPI(`blogs/all-list`, "POST", data);
export const getUserBlogs = () => api(`blogs/user-blog`, "POST");
export const publishProfile = () => api("coach/publishProfile", "POST");

// Session Api
export const coachAllSession = (data) =>
  api(`coach/getAllSession`, "GET", data);
export const coachSessionList = (data) =>
  api(`coach/getCoachSessionList`, "POST", data);
export const getSessionUsers = (data) =>
  api("coach/interestedUsers", "POST", data);

export const createSession = (data) =>
  formDataAPI(`coach/storeSession`, "POST", data);
export const deleteSession = (data) =>
  api(`coach/deleteLiveSession`, "POST", data);
export const editSession = (data) =>
  formDataAPI(`coach/editSession`, "POST", data);

export const getFreeSession = () =>
  formDataAPI(`coach/getFreeSessionList`, "POST");
export const getFreeSessionByCoachId = (id) =>
  api(`coach/getFreeSessionListByCoach/${id}`, "GET");

export const addSessionInterest = (data) =>
  api(`coach/addSessionInterest`, "POST", data);
export const changeSessionStatus = (data) =>
  api(`coach/changeSessionStatus`, "POST", data);

// Blog comments
export const addBlogComment = (data) => api(`blogs/add-comment`, "POST", data);
export const allBlogComment = (id) => api(`blogs/${id}/all-comments`, "GET");
export const deleteBlogComment = (data) =>
  api(`blogs/delete-comment`, "POST", data);
// export const addBlogComment = (data) => api(`blogs/add-comment`, "POST", data);

export const singleBlogDetails = (id) => api(`blogs/${id}/details`, "GET");
export const blogLikeDislike = (data) => api(`blogs/like`, "POST", data);
export const shareBlog = (id) => api(`blogs/${id}/share`, "GET");
export const allCategories = () => api(`blogs/categories`, "GET");
export const allAuthor = () => api(`blogs/authors`, "GET");

export const commonCategories = () => api(`common/categories`, "GET");
export const getTimezones = () => api(`common/timezones`, "GET");

export const shortListHome = (data) =>
  api(
    `coach/shorts/list?limit=${data.pageLimit}&page=${data.pageNumber}`,
    "GET"
  );

export const shortListComment = (id) =>
  api(`coach/shorts/comments/${id}`, "GET");

export const createBlog = (data) =>
  formDataAPI(`coach/blogs/create`, "POST", data);

// Fetch coach blog for edit by slug (API expects slug, not id)
export const getBlogBySlug = (slug) => api(`coach/blogs/${slug}/get`, "GET");

export const updateBlog = (data) =>
  formDataAPI(`coach/blogs/edit`, "POST", data);

// Allow optional pagination/query parameters for blog list
export const blogList = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return api(`coach/blogs/list${query ? `?${query}` : ""}`, "GET");
};

export const editBlog = (data) => formDataAPI(`coach/blogs/edit`, "POST", data);

export const deleteBlog = (data) => api(`coach/blogs/delete`, "POST", data);

export const getSocialPosts = (data) =>
  data !== undefined
    ? api(`coach/post/list?${data}`, "GET", data)
    : api(`coach/post/list`, "GET", data);

export const coachBlogList = (id) => api(`coach/blogs/${id}/get`, "GET");
export const getSingleCoachBlogList = (id) =>
  api(`coach/blogs/${id}/published-blogs`, "GET");

export const userActivityList = (id) => api(`users/activities/list`, "GET");

// Fetch posts from coaches followed by the logged-in user
export const getUserFollowedPosts = ({
  page = 1,
  limit = 10,
  type = "activity",
} = {}) =>
  api(
    `users/activities/post-list?page=${page}&limit=${limit}&type=${type}`,
    "GET"
  );

// Fetch activity posts (for /users/activities endpoint)
export const getUserActivityPosts = ({ page = 1, limit = 10 } = {}) =>
  api(
    `users/activities/post-list?page=${page}&limit=${limit}&type=activity`,
    "GET"
  );

// Fetch user shorts activities (short videos in activity stream for users)
export const getUserShortsActivities = ({ page = 1, limit = 10 } = {}) =>
  api(
    `users/activities/shorts-list?page=${page}&limit=${limit}&type=activity`,
    "GET"
  );

// Fetch stream posts (legacy /activity-stream endpoint for posts)
export const getUserStreamPosts = ({ page = 1, limit = 10 } = {}) =>
  api(
    `users/activities/post-list?page=${page}&limit=${limit}&type=stream`,
    "GET"
  );

export const getUserSessionActivities = ({ page = 1, limit = 10, type = "activity", coachId } = {}) => {
  let url = `users/activities/session-list?page=${page}&limit=${limit}&type=${type}`;
  if (coachId) url += `&coachId=${coachId}`;
  return api(url, "GET");
};

export const getCoachSessionActivities = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return api(`coach/session/get-my${query ? `?${query}` : ''}`, "GET");
};

export const myContacts = () => api("coach/followers/coach-list", "GET");
export const sessionForUsers = () => api("users/livesessions/sessions", "POST");

/**
 * Get available slots list by session
 * @param {string} type - Filter slots by type ('user' or 'coach')
 * @param {string} date - Filter by specific date (required when type='coach')
 * @param {number} session_id - The session ID to filter slots (required)
 * @param {number} [program_id] - Program ID (required when type='user')
 * @param {number} [coach_id] - Coach ID (required when type='user')
 * @param {number} [user_id] - User ID (required when type='coach')
 * @param {string} [availability_type] - 'reschedule' when fetching slots for rescheduling, or null for general availability
 * @param {string} [start_date] - Start date for range query (YYYY-MM-DD format)
 * @param {string} [end_date] - End date for range query (YYYY-MM-DD format)
 * @returns {Promise} API response
 */
export const coachAvailableSlots = (
  type,
  date,
  session_id,
  program_id,
  coach_id,
  user_id,
  availability_type = null,
  start_date = null,
  end_date = null,
  timezone = null
) => {
  const params = new URLSearchParams({
    type,
    ...(date && { date }),
    ...(session_id && { session_id }),
    ...(program_id && { program_id }),
    ...(coach_id && { coach_id }),
    ...(user_id && { user_id }),
    ...(availability_type && { availability_type }),
    ...(start_date && { start_date }),
    ...(end_date && { end_date }),
    ...(timezone && { timezone })
  });

  return api(`coach/program/coach-available-slot-list?${params.toString()}`, "GET");
};

export const uploadProfile = (data) =>
  formDataAPI(`coach/profile-image`, "PUT", data);

export const uploadBGImage = (data) =>
  formDataAPI(`coach/bg-image`, "PATCH", data);

export const userCoachUserScheduledList = (params = {}) => {
  const queryString = new URLSearchParams();
  if (params.page) queryString.append('page', params.page);
  if (params.limit) queryString.append('limit', params.limit);
  if (params.status) queryString.append('status', params.status);
  if (params.client_id) queryString.append('client_id', params.client_id);
  if (params.program_type) queryString.append('program_type', params.program_type);
  if (params.type) queryString.append('type', params.type);

  const query = queryString.toString();
  const url = `coach/program/user-coach/scheduled-list${query ? `?${query}` : ""}`;
  return api(url, "GET");
};

/**
 * Get coach's registered sessions with filtering options
 * @param {Object} params - Filter parameters
 * @param {number} [params.client_id] - Filter by specific client/user ID
 * @param {string} [params.program_type] - Filter by program type
 * @param {string} [params.status] - Filter by registration status (active, cancelled, completed)
 * @returns {Promise} API response with coach's booked program list
 */
export const getCoachBookedProgramList = (params = {}) => {
  const queryString = new URLSearchParams();

  // Add optional parameters
  if (params.client_id) queryString.append('client_id', params.client_id);
  if (params.program_type) queryString.append('program_type', params.program_type);
  if (params.status) queryString.append('status', params.status);
  if (params.page) queryString.append('page', params.page);
  if (params.limit) queryString.append('limit', params.limit);

  const query = queryString.toString();
  const url = `coach/program/coach-booked-program-list${query ? `?${query}` : ""}`;

  console.log("API Request URL:", url);
  console.log("API Request Params:", params);

  return api(url, "GET");
};

export const userScheduledList = () =>
  api("coach/program/user-scheduled-list", "GET");

export const clientsList = () => api("coach/program/clients-list", "GET");

/**
 * Get user's registered sessions with filtering options
 * @param {Object} params - Filter parameters
 * @param {number} [params.client_id] - Filter by specific client/user ID
 * @param {string} [params.program_type] - Filter by program type
 * @param {string} [params.status] - Filter by registration status (active, cancelled, completed)
 * @param {number} [params.page] - Page number for pagination
 * @param {number} [params.limit] - Number of items per page
 * @returns {Promise} API response with user's booked program list (sorted by newest first)
 */
export const userBookedProgramList = (params = {}) => {
  const queryString = new URLSearchParams();

  // Add optional parameters
  if (params.client_id) queryString.append('client_id', params.client_id);
  if (params.program_type) queryString.append('program_type', params.program_type);
  if (params.status) queryString.append('status', params.status);
  if (params.page) queryString.append('page', params.page);
  if (params.limit) queryString.append('limit', params.limit);

  const query = queryString.toString();
  const url = `coach/program/user-booked-program-list${query ? `?${query}` : ""}`;

  console.log("API Request URL:", url);
  console.log("API Request Params:", params);

  return api(url, "GET");
};

export const userBookedSlotList = () =>
  api("coach/program/user-slot-booked-list", "GET");

export const userSlotBook = (data, timezone = DateTime.local().zoneName) =>
  api(`coach/program/user-slot-book?timezone=${timezone}`, "POST", data);

export const singlePostDetails = (id) => api(`coach/post/${id}/details`, "GET");

export const paymentStatus = (data) =>
  api(`coach/program/user/program-payment-status`, "POST", data);

export const singleShortDetails = (id) =>
  api(`coach/shorts/${id}/details`, "GET");

// transaction API
export const createNewTransaction = (data) =>
  api("transactions/create", "POST", data);
export const myTransactions = () => api("transactions/my-transaction", "GET");
export const myEarnings = (params = {}) => {
  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    )
    .join("&");

  return api(
    `transactions/my-earnings${queryString ? `?${queryString}` : ""}`,
    "GET"
  );
};
export const addNewBankDetails = (data) =>
  api("transactions/add-bank-account", "POST", data);
export const deleteBankDetails = (data) =>
  api("transactions/delete-bank-account", "POST", data);
export const getBankAccountList = () =>
  api("transactions/bank-account-list", "GET");

// Coach Program API
export const cancelSession = (data) =>
  api(`coach/program/user-slot-cancel`, "POST", data);

export const getCoachBookedSlots = () =>
  api("coach/program/coach-scheduled-list", "GET");

// export const getUserBookedSlots = () =>
//   api("coach/program/user-scheduled-list", "GET");

// user-scheduled-list
export const getCoachBookedAllSlots = () =>
  api("coach/program/coach-booked-slot-list", "GET");

export const getUsersProgramsList = () => {
  api("coach/program/user-session-list", "GET");
};
export const changeProgramSessionStatus = (data) =>
  api(`coach/program/update/sessionStatus`, "POST", data);

export const changeUserProgramSessionStatus = (data) =>
  api(`coach/program/update/userSessionStatus`, "POST", data);

export const getMyCoachList = () => {
  api("coach/program/users-coach-list", "GET");
};
export const myClientsLists = () => {
  api("coach/program/coach-clients-list", "GET");
};

export const registerUsersInProgram = (data) => {
  return api("coach/program/user/program-booking", "POST", data);
};
export const addAvailability = (data) =>
  api("coach/program/create-slot", "POST", data);

export const deleteCoachAvailableSlot = (data) => {
  return api("coach/program/delete/slot", "POST", data);
};

export const updateCoachAvailableSlot = (data) => {
  return api("coach/program/update-slot", "POST", data);
};
export const getFollowersCoach = async ({
  page = 1,
  limit = 20,
  search = "",
} = {}) => {
  // New endpoint: /common/user-coach/follower-following?page=&limit=&search=
  const query = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    ...(search ? { search } : {}),
  }).toString();
  const url = `common/user-coach/follower-following${query ? `?${query}` : ""}`;
  const res = await api(url, "GET");
  // Diagnostics to verify payload shape during integration
  try {
    console.log(
      { url, status: res?.status },
      "getFollowersCoach response meta"
    );
    console.log(res?.data, "getFollowersCoach raw data");
  } catch (e) {
    // ignore console failures in some environments
  }

  // Normalize to prior shape, being resilient to backend shape changes
  const dataRoot = res?.data?.data;
  let coaches = [];
  if (Array.isArray(dataRoot)) {
    coaches = dataRoot;
  } else if (dataRoot && typeof dataRoot === "object") {
    coaches =
      dataRoot.data ||
      dataRoot.coaches ||
      dataRoot.followers ||
      dataRoot.items ||
      dataRoot.list ||
      [];
  }
  return { ...res, data: { ...res.data, data: coaches } };
};

// User follow/unfollow a coach
export const userFollowCoach = (data) =>
  formDataAPI(`users/followers/create`, "POST", data);

export const userUnfollowCoach = (data) =>
  formDataAPI(`users/followers/delete`, "POST", data);

export const userTransactions = async (queryParams) => {
  try {
    const queryString = new URLSearchParams(queryParams).toString(); // Convert object to query string
    const url = `transactions/transaction-list?${queryString}`; // Append query string
    console.log("API Request URL:", url);

    const response = await api(url, "GET"); // Ensure API call is awaited
    return response; // Return the API response
  } catch (error) {
    console.error("Error fetching user transactions:", error);
    throw error; // Handle errors properly
  }
};

export const getUserBookedSlots = async (queryParams) => {
  try {
    const queryString = new URLSearchParams(queryParams).toString(); // Convert object to query string
    const url = `coach/program/user-scheduled-list?${queryString}`; // Append query string
    console.log("API Request URL:", url);

    const response = await api(url, "GET"); // Ensure API call is awaited
    return response; // Return the API response
  } catch (error) {
    console.error("Error fetching user transactions:", error);
    throw error; // Handle errors properly
  }
};
// api("coach/program/user-scheduled-list", "GET");

export const getAllNotifications = (data) =>
  api(
    `coach/notifications?limit=${data.pageLimit}&page=${data.pageNumber}`,
    "GET"
  );

export const getAllSessionNotifications = (data) =>
  api(`notification/getAllSessionNotifications`, "POST");

export const readNotification = (data) =>
  api(`notification/readNotification`, "POST");

// Reviews APIs
// Create a review (session/program/coach)
export const submitReview = (data) => api(`reviews`, "POST", data);
// Get list of items (recent completed sessions) where user hasn't reviewed yet
export const getUnreviewedList = () => api(`reviews/get-unreviewed-list`, "GET");

// supportApi's
export const generateNewticket = (data) =>
  formDataAPI(`support/generate-ticket`, "POST", data);
export const getDepartmentList = (data) => api(`support/department`, "GET");
export const getSupportList = (data) => api(`support/list`, "GET");

export const getQuestionList = (data) => api(`support/reason`, "POST", data);
export const deleteTicket = (data) => api(`support/delete-list`, "POST", data);
export const cancelledTicket = (data) =>
  api(`support/cancelled-list`, "POST", data);

export const getCoachQuestionList = (query) =>
  api(`coach/question/list?type=${query}`, `GET`);
// export const getCoachQuestionList = (data) => api(`coach/question/list`, "GET");
export const getCoachQuestionAnswer = (query) =>
  api(`coach/question/answers?type=${query}`, "GET");
export const CoachQuestionAnswerSave = (data) =>
  formDataAPI(`coach/question/save-answer`, "POST", data);

// Comment API functions
export const commentAPI = {
  // Add a comment or reply
  addComment: async (postId, comment, parentCommentId = null) => {
    try {
      const payload = {
        post_id: postId, // Changed from postId to post_id
        comments: comment, // Changed from comment to comments
        ...(parentCommentId && { parent_comment_id: parentCommentId }), // Changed from parentCommentId to parent_comment_id
      };

      console.log("API addComment called with payload:", payload);
      console.log("API endpoint:", `coach/post/comment`);

      // Check if we have authentication
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");
      console.log("Auth token exists:", !!token);

      const response = await api(`coach/post/comment`, "POST", payload);
      console.log("API response:", response);
      return response;
    } catch (error) {
      console.error("Error adding comment:", error);
      console.error("Error details:", {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        message: error.message,
        config: error.config,
      });
      throw error;
    }
  },

  // Get comments for a post
  getComments: async (postId) => {
    try {
      console.log("Fetching comments for postId:", postId);
      console.log("API endpoint:", `coach/post/comments/${postId}`);

      const response = await api(`coach/post/comments/${postId}`, "GET");
      console.log("Raw API response:", response);
      return response;
    } catch (error) {
      console.error("Error fetching comments:", error);
      throw error;
    }
  },

  // Delete a comment
  deleteComment: async (commentId) => {
    try {
      const response = await api(`coach/post/comments/${commentId}`, "DELETE");
      return response;
    } catch (error) {
      console.error("Error deleting comment:", error);
      throw error;
    }
  },
};

// Like/Dislike API functions
export const likeAPI = {
  // Toggle like/dislike for a post
  toggleLike: async (postId) => {
    try {
      const payload = {
        post_id: postId, // Match backend schema
      };

      console.log("API toggleLike called with payload:", payload);
      console.log("API endpoint:", `coach/post/like-dislike`);

      const response = await api(`coach/post/like-dislike`, "POST", payload);
      console.log("API response:", response);
      return response;
    } catch (error) {
      console.error("Error toggling like:", error);
      console.error("Error details:", {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        message: error.message,
        config: error.config,
      });
      throw error;
    }
  },

  // Get likes for a post
  getLikes: async (postId) => {
    try {
      console.log("Fetching likes for postId:", postId);
      console.log("API endpoint:", `coach/post/getLikes/${postId}`);

      const response = await api(`coach/post/getLikes/${postId}`, "GET");
      console.log("Raw API response:", response);
      return response;
    } catch (error) {
      console.error("Error fetching likes:", error);
      throw error;
    }
  },
};

export const joinLiveSessionMeeting = (sessionId, socketId, force = false) => api(`meeting/live-session/${sessionId}/join?${socketId ? `socketId=${socketId}&` : ""}${force ? "force=true" : ""}`, "GET");
export const endLiveSessionMeeting = (sessionId) => api(`meeting/live-session/${sessionId}/end`, "POST");
export const getLiveSessionAnalytics = (sessionId) => api(`meeting/session/${sessionId}/analytics`, "GET");
export const getLiveSessionParticipants = (sessionId, params = {}) => {
  const query = new URLSearchParams(params).toString();
  return api(`meeting/session/${sessionId}/participants${query ? `?${query}` : ''}`, "GET");
};
export const getPublicSessionBySlug = (slug) => api(`meeting/session/public/${slug}`, "GET");
export const joinPublicSessionAnonymously = (slug, body) => api(`meeting/session/public/${slug}/join`, "POST", body);
export const getPublicSessionControls = (sessionId) => api(`meeting/session/${sessionId}/sharing-controls`, "GET");
export const updatePublicSessionControls = (sessionId, body) => api(`meeting/session/${sessionId}/sharing-controls`, "PUT", body);
export const submitLiveSessionFeedback = (sessionId, body) => api(`meeting/live-session/${sessionId}/feedback`, "POST", body);
export const syncLiveSessionLAD = (sessionId, body) => api(`meeting/live-session/${sessionId}/sync-lad`, "POST", body);
